$(document).ready(function(){
// announcement-bar
  $(window).on('resize', function(){
   
    var win = $(this); //this = window
//     if (win.height() >= 820) { /* ... */ }
    if (win.width() <= 991) { /* ... */ 
    $('.anounce_slider').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: false,
      dots:false,
    autoplaySpeed: 2000,
    responsive: [
        {
            breakpoint: 9999,
            settings: "unslick"
        },
        {
            breakpoint: 993,
             settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
        },
      
        {
            breakpoint: 767,
             settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
        },
        {
            breakpoint: 480,
             settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
        }
    ]
});
  }
}).resize();
// announcement-bar js  end
   // ctms-video-text js  end 
    $(".video_button").click(function(){
        $(".vdo_overlay").fadeOut();
        $(".video_button").fadeOut();
      });
       $(".vdo_overlay").click(function(){
        $(".vdo_overlay").fadeOut();
        $(".video_button").fadeOut();
      });
 // ctms-video-text js  end 

  
  $('[data-fancybox="video-gallery"]').fancybox({
	loop: true
});
  
  
 $('.ctms_responsive').slick({
  infinite: false,
  speed: 300,
  slidesToShow: 4,
   autoplay: true,
      dots:false,
    autoplaySpeed: 2000,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
           autoplay: true,
      dots:false,
    autoplaySpeed: 2000,
        slidesToScroll: 1,
        dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
                dots: true
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
  
  
   $('.image_slides').slick({
  dots: false,
  infinite: true,
  speed: 800,
  autoplay: true,
  autoplaySpeed: 2000,
  slidesToShow: 2,
  slidesToScroll: 2,
  prevArrow:"<span class='ctm_prev-arrow'><svg xmlns='http://www.w3.org/2000/svg' width='19' height='38' viewBox='0 0 19 38' fill='none'><path d='M18.5 1L0.5 19L18.5 37' stroke='black' stroke-linecap='round' stroke-linejoin='round'/></svg></span>",
  nextArrow:"<span class='ctm_next-arrow'><svg xmlns='http://www.w3.org/2000/svg' width='19' height='38' viewBox='0 0 19 38' fill='none'><path d='M0.5 37L18.5 19L0.5 1' stroke='black' stroke-linecap='round' stroke-linejoin='round'/></svg></span>",
  arrows: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
  

 $('.testimonial_slides').slick({
  dots: true,
  infinite: false,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
 
  
$('.ctms_wholesale_slide').slick({
  dots: false,
//   infinite: true,
//   speed: 500,
  slidesToShow: 3,
adaptiveHeight: true,
//    autoplay: true,
   prevArrow:"<span class='ctm_prev-arrow'><svg xmlns='http://www.w3.org/2000/svg' width='19' height='38' viewBox='0 0 19 38' fill='none'><path d='M18.5 1L0.5 19L18.5 37' stroke='black' stroke-linecap='round' stroke-linejoin='round'/></svg></span>",
  nextArrow:"<span class='ctm_next-arrow'><svg xmlns='http://www.w3.org/2000/svg' width='19' height='38' viewBox='0 0 19 38' fill='none'><path d='M0.5 37L18.5 19L0.5 1' stroke='black' stroke-linecap='round' stroke-linejoin='round'/></svg></span>",
//     autoplaySpeed: 1000,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
}); 
  
  
      // Show the first answer
    $('.accordion__answer:first').show();
    // Add the .expanded class to the first expanded answer
    $('.accordion__question:first').addClass('expanded');

    // Add a clicking event
    $('.accordion__question').on('click', function() {
        var answer = $(this).next();

	   // Show the answer by adding the .expanded class to the parent question element that was clicked on
        $('.accordion__answer').not(answer).slideUp(400);
        // Hide the previous answer by removing the .expanded class
        $('.accordion__question').not(this).removeClass('expanded');
        // Toggle (hide and show) the answer by clicking on the question element
        $(this).toggleClass('expanded');
        // Add animation so that the answers would show and hide smoothly
        answer.slideToggle(400);
    });
  
  
 $('[data-fancybox="cooking-video-gallery"]').fancybox({
	loop: true
});

    var $status = $('.pagingInfo');
    var $slickElement = $('.c_video_slides');

    $slickElement.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide) {
      //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
      var i = (currentSlide ? currentSlide : 0) + 1;
      $status.text(i + '/' + slick.slideCount);
    });

//     $slickElement.slick({
//       slide: '.slide-placeholder',
//       autoplay: true,
//       dots: true
//     });  
  
  
$('.c_video_slides').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesPerRow: 3,
  adaptiveHeight: true,
  rows: 5,
  prevArrow:'<svg class="slick_arrows prev-arrow slick-prev slick-arrow" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" class="arrow"></path></svg>',
  nextArrow:'<svg class="slick_arrows next-arrow slick-next slick-arrow" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>',
  nav:true,
  
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        slidesPerRow: 2,
   		rows: 5,
        dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesPerRow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesPerRow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
  
  

$('[data-fancybox="on-tv-video-gallery"]').fancybox({
	loop: true
});

  
  
$('.o_video_slides').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  adaptiveHeight: true,
  slidesPerRow: 3,
  rows: 5,
  slidesToScroll: 1,
   prevArrow:'<svg class="slick_arrows prev-arrow slick-prev slick-arrow" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" class="arrow"></path></svg>',
  nextArrow:'<svg class="slick_arrows next-arrow slick-next slick-arrow" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>',
  nav:true,
  
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        slidesPerRow: 2,
   		rows: 5,
        dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesPerRow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesPerRow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
}); 
  
$('[data-fancybox="how-video-gallery"]').fancybox({
	loop: true
});

  
  $(".card_add_to").click(function(){
  var value = parseInt($(".cart_count").text(), 10);
  	
  var update_count = (value+1);
    
    $(".cart_count").text(update_count);
//     $('.cart-notification').addClass('active');
  });
  
  
//   var myVar = window.location.href;
   
//   alert(url);
  
//   var pattern = /#accordion__item_3/;

//returns true or false...
// var exists = pattern.test(myVar);

// if (exists){
	

  
//   $('#accordion__item_3 .accordion__question').addClass('expanded');
  
 

//  }
 
//   if( url:"contains('#accordion__item_3')"){
//   	alert(url);
//   }
  
$('#tabs-nav li:first-child').addClass('active');
$('.tab-content').hide();
$('.tab-content:first').show();

// Click function
$('#tabs-nav li').click(function(){
  $('#tabs-nav li').removeClass('active');
  $(this).addClass('active');
  $('.tab-content').hide();
  
  var activeTab = $(this).find('a').attr('href');
  $(activeTab).fadeIn();
  return false;
});
   
   
   
   
       $('.main_slide').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      adaptiveHeight: true,
      fade: true,
        asNavFor: '.ct_thumbnail ul'
    });
    $('.ct_thumbnail ul').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      vertical:false,
      asNavFor: '.main_slide',
      dots: false,
      prevArrow:'<svg class="slick-prev slick-arrow" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"></polyline></svg>',
    nextArrow:'<svg class="slick-next slick-arrow" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg>',
      arrows:true,
      focusOnSelect: true,
      adaptiveHeight: true,
      centerMode: false,
         responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            arrows:true,
            centerMode: false,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 749,
          settings: {
            vertical: false,
            verticalSwiping:false,
            slidesToShow: 4,
            arrows:true,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 580,
          settings: {
            vertical: false,
            verticalSwiping:false,
            arrows:true,
            slidesToShow: 3
          }
        },
        {
          breakpoint: 380,
          settings: {
            vertical: false,
            verticalSwiping:false,
            arrows:true,
            slidesToShow: 3
          }
        }
      ]
    });
  
  
});